(function () {
  window.WorkshopPreventivoLoaded = true;

  document.addEventListener("click", function (e) {
    const button = e.target.closest('[data-action="genera-preventivo-pdf"]');
    if (!button) return;

    const form = button.closest("#form-preventivo-carrello");
    if (!form) return;

    e.preventDefault();
    handlePreventivoRequest(e, form);
  }, true);

  document.addEventListener("submit", function (e) {
    const form = e.target.closest("#form-preventivo-carrello");
    if (!form) return;

    e.preventDefault();
    handlePreventivoRequest(e, form);
  }, true);

  async function handlePreventivoRequest(e, form) {
    if (form.reportValidity && !form.reportValidity()) return;

    const VAT_RATE = parseFloat(form.dataset.vatRate || "0.22");
    const VAT_MULTIPLIER = 1 + VAT_RATE;
    const PAGE_MARGIN = 10;

    let numeroPreventivo = localStorage.getItem("numero_preventivo");
    if (!numeroPreventivo) numeroPreventivo = 1001;
    else numeroPreventivo = parseInt(numeroPreventivo, 10) + 1;
    localStorage.setItem("numero_preventivo", numeroPreventivo);

    const data = {
      nome: form.nome.value,
      cognome: form.cognome.value,
      azienda: form.azienda.value,
      indirizzo: form.indirizzo.value,
      piva: form.piva.value,
      note: form.note.value,
      includeImages: form.include_images ? form.include_images.checked : false
    };

    if (!window.jspdf || !window.jspdf.jsPDF || !window.jspdf.jsPDF.API.autoTable) {
      alert("Impossibile generare il preventivo: librerie PDF non caricate. Ricarica la pagina e riprova.");
      return;
    }

    const cartRes = await fetch("/cart.js");
    const cart = await cartRes.json();
    const productImages = data.includeImages ? await Promise.all(cart.items.map(item => loadProductImage(item.image))) : [];

    const logo = new Image();
    logo.crossOrigin = "anonymous";
    logo.src = addCacheBuster(form.dataset.logoUrl || "", form.dataset.logoVersion || "20");

    let pdfGenerated = false;
    const generatePDFOnce = function () {
      if (pdfGenerated) return;
      pdfGenerated = true;
      generatePDF();
    };

    logo.onload = generatePDFOnce;
    logo.onerror = generatePDFOnce;
    if (logo.complete) generatePDFOnce();

    function generatePDF() {
        const doc = new window.jspdf.jsPDF();
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        const formatMoney = cents => (cents / 100).toLocaleString("it-IT", {
          style: "currency",
          currency: "EUR"
        });
        const formatMoneyFromNumber = value => value.toLocaleString("it-IT", {
          style: "currency",
          currency: "EUR"
        });
        const grossCentsToNetAmount = cents => (cents / 100) / VAT_MULTIPLIER;
        const addFooter = function () {
          const pageCount = doc.internal.getNumberOfPages();

          for (let i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            doc.setFont("helvetica", "normal");
            doc.setFontSize(8);
            doc.setTextColor(120);
            doc.text(`Preventivo n. ${numeroPreventivo}`, PAGE_MARGIN, pageHeight - 8);
            doc.text(`Pagina ${i} di ${pageCount}`, pageWidth - PAGE_MARGIN, pageHeight - 8, { align: "right" });
          }
        };
        const ensureSpace = function (currentY, neededHeight) {
          if (currentY + neededHeight <= pageHeight - 18) return currentY;

          doc.addPage();
          return 18;
        };

        doc.setDrawColor(220);
        doc.line(PAGE_MARGIN, 42, pageWidth - PAGE_MARGIN, 42);
        if (logo.complete && logo.naturalWidth > 0) {
          doc.addImage(logo, "PNG", PAGE_MARGIN, 10, 70, 0);
        } else {
          doc.setFont("helvetica", "bold");
          doc.setFontSize(16);
          doc.setTextColor(35);
          doc.text("Workshop Italy", PAGE_MARGIN, 24);
        }

        const clienteX = 118;
        const clienteWidth = pageWidth - clienteX - PAGE_MARGIN;
        let clienteY = 14;
        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);
        doc.setTextColor(40);
        doc.text("Dati cliente", clienteX, clienteY);
        clienteY += 6;
        doc.setFont("helvetica", "normal");
        doc.setFontSize(9);
        [
          `${data.nome} ${data.cognome}`,
          data.azienda,
          data.indirizzo,
          `P.IVA / CF: ${data.piva}`
        ].forEach(line => {
          const wrappedLine = doc.splitTextToSize(line, clienteWidth);
          doc.text(wrappedLine, clienteX, clienteY);
          clienteY += wrappedLine.length * 5;
        });

        const startY = 55;
        const dataOggi = new Date().toLocaleDateString("it-IT");
        doc.setFont("helvetica", "bold");
        doc.setTextColor(20);
        doc.setFontSize(14);
        doc.text(`Preventivo n. ${numeroPreventivo}`, PAGE_MARGIN, startY);
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        doc.setTextColor(90);
        doc.text(`Data: ${dataOggi}`, pageWidth - PAGE_MARGIN, startY, { align: "right" });

        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        doc.setTextColor(40);
        doc.text("La presente per proporvi nostra migliore offerta per il materiale elencato di seguito:", PAGE_MARGIN, startY + 10);

        const headers = data.includeImages
          ? [["Foto", "Prodotto", "Variante", "Q.tà", "Unit. IVA escl.", "Unit. IVA incl.", "Tot. IVA escl.", "Tot. IVA incl."]]
          : [["Prodotto", "Variante", "Q.tà", "Unit. IVA escl.", "Unit. IVA incl.", "Tot. IVA escl.", "Tot. IVA incl."]];
        const lineGrossTotal = item => item.final_line_price || item.final_price * item.quantity;
        const rows = cart.items.map((item, index) => {
          const unitGross = item.final_price;
          const totalGross = lineGrossTotal(item);
          const row = [
            item.product_title,
            item.variant_title || "-",
            item.quantity.toString(),
            formatMoneyFromNumber(grossCentsToNetAmount(unitGross)),
            formatMoney(unitGross),
            formatMoneyFromNumber(grossCentsToNetAmount(totalGross)),
            formatMoney(totalGross)
          ];

          if (data.includeImages) row.unshift(productImages[index] ? "" : "-");

          return row;
        });
        const productTableColumnStyles = data.includeImages ? {
          0: { cellWidth: 18, halign: "center", valign: "middle" },
          1: { cellWidth: 42 },
          2: { cellWidth: 24 },
          3: { cellWidth: 10, halign: "center" },
          4: { cellWidth: 22, halign: "right" },
          5: { cellWidth: 22, halign: "right" },
          6: { cellWidth: 25, halign: "right" },
          7: { cellWidth: 27, halign: "right" }
        } : {
          0: { cellWidth: 54 },
          1: { cellWidth: 28 },
          2: { cellWidth: 12, halign: "center" },
          3: { cellWidth: 24, halign: "right" },
          4: { cellWidth: 24, halign: "right" },
          5: { cellWidth: 24, halign: "right" },
          6: { cellWidth: 24, halign: "right" }
        };

        doc.autoTable({
          head: headers,
          body: rows,
          startY: startY + 18,
          theme: "grid",
          styles: {
            font: "helvetica",
            fontSize: data.includeImages ? 7.2 : 8,
            cellPadding: data.includeImages ? 1.6 : 2,
            lineColor: [225, 225, 225],
            lineWidth: 0.1,
            textColor: [35, 35, 35],
            valign: "middle"
          },
          bodyStyles: {
            minCellHeight: data.includeImages ? 18 : 0
          },
          headStyles: {
            fillColor: [35, 35, 35],
            textColor: [255, 255, 255],
            fontStyle: "bold",
            halign: "center",
            fontSize: data.includeImages ? 7 : 8,
            cellPadding: data.includeImages ? { top: 1.1, right: 1, bottom: 1.1, left: 1 } : 2,
            minCellHeight: 0
          },
          alternateRowStyles: { fillColor: [248, 248, 248] },
          margin: { left: PAGE_MARGIN, right: PAGE_MARGIN },
          tableWidth: "auto",
          columnStyles: productTableColumnStyles,
          rowPageBreak: "avoid",
          didParseCell: function (hookData) {
            if (data.includeImages && hookData.section === "body" && hookData.column.index === 0) {
              hookData.cell.styles.fillColor = [255, 255, 255];
            }
          },
          didDrawCell: function (hookData) {
            if (!data.includeImages || hookData.section !== "body" || hookData.column.index !== 0) return;

            const imageData = productImages[hookData.row.index];
            if (!imageData) return;

            const imageSize = 14;
            const imageX = hookData.cell.x + (hookData.cell.width - imageSize) / 2;
            const imageY = hookData.cell.y + (hookData.cell.height - imageSize) / 2;
            doc.addImage(imageData, "JPEG", imageX, imageY, imageSize, imageSize);
          }
        });

        const totalGrossCents = cart.total_price || cart.items.reduce((total, item) => total + lineGrossTotal(item), 0);
        const totalNetAmount = grossCentsToNetAmount(totalGrossCents);
        const totalVatAmount = (totalGrossCents / 100) - totalNetAmount;
        let currentY = ensureSpace(doc.lastAutoTable.finalY + 8, 42);

        doc.autoTable({
          body: [
            ["Totale IVA esclusa", formatMoneyFromNumber(totalNetAmount)],
            [`IVA ${Math.round(VAT_RATE * 100)}%`, formatMoneyFromNumber(totalVatAmount)],
            ["Totale IVA inclusa", formatMoney(totalGrossCents)]
          ],
          startY: currentY,
          theme: "grid",
          styles: {
            font: "helvetica",
            fontSize: 10,
            cellPadding: 2.5,
            lineColor: [225, 225, 225],
            lineWidth: 0.1
          },
          bodyStyles: { textColor: [35, 35, 35] },
          margin: { left: 118, right: PAGE_MARGIN },
          tableWidth: pageWidth - 118 - PAGE_MARGIN,
          columnStyles: {
            0: { fontStyle: "bold" },
            1: { halign: "right" }
          },
          didParseCell: function (hookData) {
            if (hookData.row.index === 2) {
              hookData.cell.styles.fillColor = [35, 35, 35];
              hookData.cell.styles.textColor = [255, 255, 255];
              hookData.cell.styles.fontStyle = "bold";
            }
          }
        });

        currentY = doc.lastAutoTable.finalY + 10;
        if (data.note.trim() !== "") {
          currentY = ensureSpace(currentY, 32);
          doc.setFont("helvetica", "bold");
          doc.setFontSize(10);
          doc.setTextColor(40);
          doc.text("Note cliente", PAGE_MARGIN, currentY);
          doc.setFont("helvetica", "normal");
          doc.setFontSize(10);
          const noteLines = doc.splitTextToSize(data.note.trim(), pageWidth - PAGE_MARGIN * 2);
          doc.text(noteLines, PAGE_MARGIN, currentY + 6);
          currentY += 10 + (noteLines.length * 5);
        }

        currentY = ensureSpace(currentY + 2, 36);
        doc.setDrawColor(235);
        doc.line(PAGE_MARGIN, currentY, pageWidth - PAGE_MARGIN, currentY);
        currentY += 8;

        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);
        doc.setTextColor(40);
        doc.text("Metodi di pagamento", PAGE_MARGIN, currentY);
        doc.setFont("helvetica", "normal");
        doc.text("Carta di credito - PayPal - Bonifico bancario anticipato", PAGE_MARGIN, currentY + 6);

        doc.setFont("helvetica", "bold");
        doc.text("Validità preventivo", PAGE_MARGIN, currentY + 18);
        doc.setFont("helvetica", "normal");
        doc.text("Il seguente preventivo ha una validità di 30 giorni, salvo esaurimento scorte o cambio listino da parte del fornitore.", PAGE_MARGIN, currentY + 24, { maxWidth: pageWidth - PAGE_MARGIN * 2 });

        addFooter();
        doc.save(`preventivo_${numeroPreventivo}.pdf`);
    }
  }

  function loadProductImage(imageUrl) {
    return new Promise(resolve => {
      if (!imageUrl) {
        resolve(null);
        return;
      }

      const image = new Image();
      image.crossOrigin = "anonymous";
      image.onload = function () {
        try {
          const canvas = document.createElement("canvas");
          const size = 140;
          const ratio = Math.min(size / image.naturalWidth, size / image.naturalHeight);
          const width = image.naturalWidth * ratio;
          const height = image.naturalHeight * ratio;
          const x = (size - width) / 2;
          const y = (size - height) / 2;
          const context = canvas.getContext("2d");

          canvas.width = size;
          canvas.height = size;
          context.fillStyle = "#ffffff";
          context.fillRect(0, 0, size, size);
          context.drawImage(image, x, y, width, height);
          resolve(canvas.toDataURL("image/jpeg", 0.82));
        } catch (error) {
          resolve(null);
        }
      };
      image.onerror = function () {
        resolve(null);
      };
      image.src = normalizeImageUrl(imageUrl);
    });
  }

  function normalizeImageUrl(imageUrl) {
    if (imageUrl.indexOf("//") === 0) return window.location.protocol + imageUrl;
    return imageUrl;
  }

  function addCacheBuster(url, version) {
    if (!url) return "";

    const separator = url.indexOf("?") === -1 ? "?" : "&";
    return `${url}${separator}preventivo_logo=${encodeURIComponent(version)}`;
  }
})();
